const form = {
  formId: "oil-gas-01",
  formField: {
    checkbox1: {
      name: "checkbox1",
      label: "[01] Dầu thô",
      type: "text",
    },
    checkbox2: {
      name: "checkbox2",
      label: "[02] Condensate",
      type: "text",
    },
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[03] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[03a] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03b] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId: {
      name: "taxId",
      label: "[05] Mã số thuế người nộp thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    contract: {
      name: "contract",
      label: "[12] Hợp đồng dầu khí lô",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập mã hợp đồng",
    },
    checkbox3: {
      name: "checkbox1",
      label: "[13] Tên đơn vị được ủy quyền",
      type: "text",
    },
    checkbox4: {
      name: "checkbox2",
      label: "Hoặc đại lý thuế",
      type: "text",
    },
    taxId2: {
      name: "taxId2",
      label: "[14] Mã số thuế đơn vị được ủy quyền/đại lý thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    moneyType: {
      name: "moneyType",
      label: "Loại đơn vị tiền",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn",
    },

    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
